export default __webpack_public_path__ + "2927a716e9eabba043542e42d0f22fc3.png";